import countryCode from './countryCode'

export const languages = {
  en_JP: 'English',
  en_HK: 'English',
  en_ID: 'English',
  en_NZ: 'English',
  en_MO: 'English',
  en_MY: 'English',
  en_SG: 'English',
  en_SA: 'English',
  en_PE: 'English',
  en_GB: 'English',
  en_US: 'English',
  en_VN: 'English',
  en_TW: 'English',
  en_TH: 'English',
  zh_HK: '繁體中文',
  zh_TW: '繁體中文',
  zh_MO: '繁體中文',
  zh_MY: '中文',
  zh_SG: '中文',
  vi_VN: 'Tiếng Việt',
  th_TH: 'ไทย',
  ar_SA: 'Arabic',
  bm_MY: 'Bahasa',
  ja_JP: '日本語'
}

export const getLanguageCode = (language = '', country = ''): string => {
  if (language === 'zh') {
    // WORKAROUND: Hong Kong & Taiwan use traditional Chinese.
    // Need to explicitly specify traditional/simplified Chinese in google maps.
    switch (country) {
      case 'HK':
      case 'TW':
        return 'zh-TW'
      default:
        return 'zh-CN'
    }
  }
  return language
}

// Map v3 server side localisation to v3.1 localisation
const MESSAGES_MAPPING = {
  'cartv3.cart.errorMessage.zeroAmountCheckoutWithOnlinePayment':
    'You cannot check out when the amount is 0.'
}
export const getMessage = (message: string): string =>
  MESSAGES_MAPPING[message] || message

export const parseLocale = (
  locale = ''
): {
  language: string
  country: string
} => {
  const [language, country] = locale.split('_')
  return {
    language,
    country
  }
}

// TEMPORARY FIX: Please refer to https://oddle-pm.atlassian.net/browse/FESC-1217 for any update on the proper fix
const reversedLanguages = {
  en_HK: '繁體中文',
  en_TW: '繁體中文',
  en_VN: 'Tiếng Việt',
  en_JP: '日本語',
  en_MO: '繁體中文',
  en_TH: 'ไทย',
  en_SA: 'Arabic',
  en_SG: '中文'
}

// TEMPORARY FIX: Please refer to https://oddle-pm.atlassian.net/browse/FESC-1217 for any update on the proper fix
export const getLanguageDropdownLabel = (locale: string): string =>
  reversedLanguages[locale] || 'English'

// TEMPORARY FIX: Please refer to https://oddle-pm.atlassian.net/browse/FESC-1217 for any update on the proper fix
const reversedSelectLanguage = {
  en_HK: '選擇語言',
  en_TW: '選擇語言',
  en_VN: 'Chọn Ngôn ngữ',
  en_MO: '選擇語言'
}

// TEMPORARY FIX: Please refer to https://oddle-pm.atlassian.net/browse/FESC-1217 for any update on the proper fix
export const getSelectLanguageDropdownLabel = (locale: string): string =>
  reversedSelectLanguage[locale] || 'Select Language'

  export const getDialCode = (key: string): string => {
    const collection = countryCode.find(
      (country) => country.name.toLowerCase() === (key || '').toLowerCase()
    )

    return collection ? collection.dial_code : ''
  }

  export const getCountryNameByDialCode = (dialCode: string): string => {
    const collection = countryCode.find(
      (country) => country.dial_code === dialCode
    )

    return collection ? collection.name : ''
  }

  export const getShortCountryName = (countryName: string): string => {
    const collection = countryCode.find(
      (country) =>
        country.name.toLowerCase() === (countryName || '').toLowerCase()
    )

    return collection ? collection.code : ''
  }
